import { TwoFactorResponse } from "@sp-crm/core";
import { Action } from "redux";
import { Actions } from "../actions";
import { TwoFactorAction } from "../actions/types";

export interface IResetPasswordState {
    inProgress: boolean;
    isSuccessful: boolean;
    isFailed: boolean;
    requiresTwoFactor: boolean;
    twoFactorData: TwoFactorResponse | null;
}

export function resetPasswordReducer(
    state: IResetPasswordState,
    action: Action,
): IResetPasswordState {
    if (!state || action.type === Actions[Actions.LOGOUT]) {
        return {
            inProgress: false,
            isSuccessful: false,
            isFailed: false,
            requiresTwoFactor: false,
            twoFactorData: null,
        };
    }

    switch (action.type) {
        case Actions[Actions.RESET_PASSWORD_START]:
            return {
                ...state,
                ...{
                    inProgress: true,
                    isSuccessful: false,
                    isFailed: false,
                    requiresTwoFactor: false,
                    twoFactorData: null,
                },
            };
        case Actions[Actions.RESET_PASSWORD_SUCCESS]:
            return {
                ...state,
                ...{
                    inProgress: false,
                    isSuccessful: true,
                    isFailed: false,
                    requiresTwoFactor: false,
                    twoFactorData: null,
                },
            };
        case Actions[Actions.RESET_PASSWORD_REQUIRES_2FA]:
            return {
                ...state,
                ...{
                    inProgress: false,
                    isSuccessful: false,
                    isFailed: false,
                    requiresTwoFactor: true,
                    twoFactorData: (action as TwoFactorAction).twoFactorData,
                },
            };
        case Actions[Actions.RESET_PASSWORD_CLEAR_2FA]:
            return {
                ...state,
                ...{
                    inProgress: false,
                    isSuccessful: false,
                    isFailed: false,
                    requiresTwoFactor: false,
                    twoFactorData: null,
                },
            };
        case Actions[Actions.RESET_PASSWORD_FAILED]:
            return {
                ...state,
                ...{
                    inProgress: false,
                    isSuccessful: false,
                    isFailed: true,
                    requiresTwoFactor: false,
                    twoFactorData: null,
                },
            };
        default:
            return state;
    }
}
